export default "__VITE_ASSET__BxVfJ4zF__"